export const StandardDateFromat = 'YYYY-MM-DD';